import React, { useState } from 'react';
import {
  View,
  Text,
  StyleSheet,
  ScrollView,
  TouchableOpacity,
  SafeAreaView,
  Linking,
  TextInput,
  Platform,
} from 'react-native';
import { MaterialCommunityIcons } from '@expo/vector-icons';
import { LinearGradient } from 'expo-linear-gradient';
import { useTheme } from '../screens/ThemeContext';

const FAQData = [
  {
    question: 'Comment télécharger un document ?',
    answer: 'Pour télécharger un document, vous devez d\'abord l\'acheter. Une fois acheté, le document sera disponible dans votre historique.'
  },
  {
    question: 'Comment effectuer un paiement ?',
    answer: 'Nous acceptons les paiements via Orange Money et MTN Mobile Money. Sélectionnez votre mode de paiement préféré lors de l\'achat.'
  },
  {
    question: 'Je n\'arrive pas à ouvrir un document',
    answer: 'Assurez-vous d\'avoir une application PDF reader installée sur votre appareil. Si le problème persiste, contactez notre support.'
  },
  {
    question: 'Comment devenir un centre partenaire ?',
    answer: 'Pour devenir un centre partenaire, inscrivez-vous comme centre et soumettez vos documents pour validation.'
  }
];

const ContactMethods = [
  {
    id: 'whatsapp',
    icon: 'whatsapp',
    title: 'WhatsApp',
    subtitle: 'Réponse rapide 24/7',
    action: () => Linking.openURL('https://wa.me/237671454061')
  },
  {
    id: 'email',
    icon: 'email',
    title: 'Email',
    subtitle: 'jobs@cameroondesks.com',
    action: () => Linking.openURL('mailto:jobs@cameroondesks.com')
  },
  {
    id: 'phone',
    icon: 'phone',
    title: 'Téléphone',
    subtitle: '+237 691 28 61 36',
    action: () => Linking.openURL('tel:+237691286136')
  }
];

export default function SupportScreen({ navigation }) {
  const [expandedQuestion, setExpandedQuestion] = useState(null);
  const [message, setMessage] = useState('');
  const { theme } = useTheme();

  const renderContactMethod = (method) => (
    <TouchableOpacity 
      key={method.id}
      style={[styles.contactCard, { backgroundColor: theme.surface, borderColor: theme.border }]}
      onPress={method.action}
    >
      <View style={styles.contactCardContent}>
        <View style={[styles.contactIcon, { backgroundColor: theme.background }]}>
          <MaterialCommunityIcons name={method.icon} size={24} color={theme.primary} />
        </View>
        <View style={styles.contactInfo}>
          <Text style={[styles.contactTitle, { color: theme.text }]}>{method.title}</Text>
          <Text style={[styles.contactSubtitle, { color: theme.textSecondary }]}>{method.subtitle}</Text>
        </View>
        <MaterialCommunityIcons name="chevron-right" size={24} color={theme.textSecondary} />
      </View>
    </TouchableOpacity>
  );

  const renderFAQItem = (item, index) => (
    <TouchableOpacity
      key={index}
      style={[
        styles.faqItem,
        { 
          backgroundColor: theme.surface, 
          borderColor: expandedQuestion === index ? theme.primary : theme.border 
        }
      ]}
      onPress={() => setExpandedQuestion(expandedQuestion === index ? null : index)}
    >
      <View style={styles.faqHeader}>
        <Text style={[styles.faqQuestion, { color: theme.text }]}>{item.question}</Text>
        <MaterialCommunityIcons
          name={expandedQuestion === index ? 'chevron-up' : 'chevron-down'}
          size={24}
          color={theme.textSecondary}
        />
      </View>
      {expandedQuestion === index && (
        <Text style={[
          styles.faqAnswer, 
          { 
            color: theme.textSecondary,
            borderTopColor: theme.border 
          }
        ]}>
          {item.answer}
        </Text>
      )}
    </TouchableOpacity>
  );

  return (
    <SafeAreaView style={[styles.safeArea, { backgroundColor: theme.background }]}>
      

      <ScrollView style={styles.container} showsVerticalScrollIndicator={false}>
        <View style={[styles.header, { borderBottomColor: theme.border }]}>
        <TouchableOpacity 
          style={[styles.backButton, { backgroundColor: theme.surface, borderColor: theme.border }]}
          onPress={() => navigation.goBack()}
        >
          <MaterialCommunityIcons 
            name="arrow-left" 
            size={24} 
            color={theme.primary} 
          />
        </TouchableOpacity>
        <Text style={[styles.headerTitle, { color: theme.text }]}>Support Client</Text>
      </View>
        {/* Message de bienvenue */}
        <View style={styles.welcomeSection}>
          <Text style={[styles.welcomeTitle, { color: theme.text }]}>Comment pouvons-nous vous aider ?</Text>
          <Text style={[styles.welcomeText, { color: theme.textSecondary }]}>
            Notre équipe est disponible pour répondre à toutes vos questions.
          </Text>
        </View>

        {/* Méthodes de contact */}
        <View style={styles.section}>
          <Text style={[styles.sectionTitle, { color: theme.text }]}>Nous contacter</Text>
          <View style={styles.contactGrid}>
            {ContactMethods.map(renderContactMethod)}
          </View>
        </View>

        {/* FAQ */}
        <View style={styles.section}>
          <Text style={[styles.sectionTitle, { color: theme.text }]}>Questions fréquentes</Text>
          <View style={styles.faqContainer}>
            {FAQData.map(renderFAQItem)}
          </View>
        </View>

        {/* Formulaire de message */}
        {/* <View style={styles.section}>
          <Text style={[styles.sectionTitle, { color: theme.text }]}>Envoyez-nous un message</Text>
          <View style={styles.messageForm}>
            <TextInput
              style={[styles.messageInput, { backgroundColor: theme.input, color: theme.text }]}
              placeholder="Décrivez votre problème..."
              multiline
              numberOfLines={4}
              value={message}
              onChangeText={setMessage}
              placeholderTextColor={theme.textSecondary}
            />
            <TouchableOpacity 
              style={styles.sendButton}
              onPress={() => {
                // Logique d'envoi du message
                setMessage('');
              }}
            >
              <LinearGradient
                colors={[theme.primary, theme.primaryDark || theme.primary]}
                style={styles.sendButtonGradient}
              >
                <Text style={styles.sendButtonText}>Envoyer</Text>
                <MaterialCommunityIcons name="send" size={20} color="#fff" />
              </LinearGradient>
            </TouchableOpacity>
          </View>
        </View> */}

        {/* Heures de support */}
        <View style={styles.supportHours}>
          <MaterialCommunityIcons name="clock-outline" size={20} color={theme.textSecondary} />
          <Text style={[styles.supportHoursText, { color: theme.textSecondary }]}>
            Support disponible du Lundi au Samedi, 8h - 18h
          </Text>
        </View>

        <View style={styles.bottomSpace} />
      </ScrollView>
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  safeArea: {
    flex: 1,
  },
  container: {
    flex: 1,
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: 16,
    borderBottomWidth: 1,
  },
  backButton: {
    padding: 8,
    marginRight: 16,
    borderRadius: 12,
  },
  headerTitle: {
    fontSize: 20,
    fontWeight: 'bold',
  },
  welcomeSection: {
    padding: 20,
    alignItems: 'center',
  },
  welcomeTitle: {
    fontSize: 24,
    fontWeight: 'bold',
    marginBottom: 8,
    textAlign: 'center',
  },
  welcomeText: {
    fontSize: 16,
    textAlign: 'center',
    lineHeight: 22,
  },
  section: {
    padding: 20,
  },
  sectionTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    marginBottom: 15,
  },
  contactGrid: {
    gap: 12,
  },
  contactCard: {
    borderRadius: 12,
    borderWidth: 1,
    overflow: 'hidden',
  },
  contactCardContent: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: 15,
  },
  contactIcon: {
    width: 40,
    height: 40,
    borderRadius: 20,
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 12,
  },
  contactInfo: {
    flex: 1,
  },
  contactTitle: {
    fontSize: 16,
    fontWeight: '600',
    marginBottom: 4,
  },
  contactSubtitle: {
    fontSize: 14,
  },
  faqContainer: {
    gap: 10,
  },
  faqItem: {
    borderRadius: 12,
    borderWidth: 1,
    overflow: 'hidden',
  },
  faqHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 15,
  },
  faqQuestion: {
    flex: 1,
    fontSize: 16,
    fontWeight: '500',
    marginRight: 10,
  },
  faqAnswer: {
    fontSize: 14,
    lineHeight: 20,
    paddingHorizontal: 15,
    paddingBottom: 15,
    borderTopWidth: 1,
  },
  messageForm: {
    gap: 15,
  },
  messageInput: {
    borderRadius: 12,
    padding: 15,
    fontSize: 16,
    minHeight: 120,
    textAlignVertical: 'top',
  },
  sendButton: {
    borderRadius: 12,
    overflow: 'hidden',
  },
  sendButtonGradient: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 15,
    gap: 8,
  },
  sendButtonText: {
    color: '#fff',
    fontSize: 16,
    fontWeight: 'bold',
  },
  supportHours: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 20,
    gap: 8,
  },
  supportHoursText: {
    fontSize: 14,
  },
  bottomSpace: {
    height: 40,
  },
});